module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_02_1280_1280_ja-ee0fb963d9024beb0e8af86c41ffb11a.jpg";